var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "domain-settings domain-description",
      class: { loading: _vm.loading }
    },
    [
      _c("header", [_c("h3", [_vm._v(_vm._s(_vm.domain))])]),
      _vm._v(" "),
      _vm.domainConfig
        ? _c("detail-list", {
            attrs: {
              item: _vm.domainConfig,
              title: "Domain " + _vm.domain + " Configuration"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb8f4f20", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb8f4f20","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/domain/domain-settings.vue
// module id = 1708
// module chunks = 0